import { useRouter } from "next/router";
import { PromotionContextProvider } from "src/contexts/promotion.context";
import { ProductView } from "src/organisms/ProductView";

const ProductPage = (): JSX.Element => {
  const {
    query: { productSlug },
  } = useRouter();
  return (
    <PromotionContextProvider>
      <ProductView slug={productSlug as string} />
    </PromotionContextProvider>
  );
};

export default ProductPage;
